// extracted by mini-css-extract-plugin
export default {"tabs":"versionSubTabs__tabs-Vfhop"};